import React, { forwardRef } from "react";
import type { LucideIcon, LucideProps } from "lucide-react";

import { twMerge } from "@/design-system/twMerge";

export const ICON_SIZES = {
  xs: { className: "size-icon-xs", strokeWidth: 2 },
  sm: { className: "size-icon-sm", strokeWidth: 2 },
  md: { className: "size-icon-md", strokeWidth: 2 },
  lg: { className: "size-icon-lg", strokeWidth: 2 },
  xl: { className: "size-icon-xl", strokeWidth: 1.5 },
} as const;

export type IconSize = keyof typeof ICON_SIZES;

export type IconProps = Omit<LucideProps, "ref" | "size" | "strokeWidth"> & {
  icon: LucideIcon;
  size?: IconSize;
};

export const Icon = forwardRef<SVGSVGElement, IconProps>(
  (
    { icon: Glyph, size = "md", className, "aria-hidden": ariaHidden, ...rest },
    ref,
  ) => {
    const token = ICON_SIZES[size];
    return (
      <Glyph
        ref={ref}
        className={twMerge(token.className, className)}
        strokeWidth={token.strokeWidth}
        aria-hidden={ariaHidden ?? true}
        {...rest}
      />
    );
  },
);

Icon.displayName = "Icon";
